import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

const Pagination = ({ currentPage, totalPages }) => {
  const navigate = useNavigate();
  const location = useLocation();

  if (totalPages <= 1) {
    return null;
  }

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    const searchParams = new URLSearchParams(location.search);
    searchParams.set('page', pageNumber);
    navigate(`${location.pathname}?${searchParams.toString()}`);
  };

  const getPageNumbers = () => {
    const pageNumbers = [];
    const pageRange = 4; // How many pages to show around the current page
    const startPage = Math.max(2, currentPage - pageRange);
    const endPage = Math.min(totalPages - 1, currentPage + pageRange);

    // Always show the first page
    pageNumbers.push(1);

    // Show ellipsis if there's a gap after the first page
    if (startPage > 2) {
      pageNumbers.push('...');
    }

    // Show pages around the current page
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    // Show ellipsis if there's a gap before the last page
    if (endPage < totalPages - 1) {
      pageNumbers.push('...');
    }

    // Always show the last page
    if (totalPages > 1) {
      pageNumbers.push(totalPages);
    }

    return pageNumbers;
  };

  const pageNumbers = getPageNumbers();

  return (
    <div className="flex justify-center mt-6">
      <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-700 bg-gray-700 text-sm font-medium text-text-white hover:bg-gray-600 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <FontAwesomeIcon icon={faChevronLeft} />
        </button>
        {pageNumbers.map((number, index) =>
          typeof number === 'number' ? (
            <button
              key={index}
              onClick={() => handlePageChange(number)}
              className={`relative inline-flex items-center px-4 py-2 border border-gray-700 bg-gray-700 text-sm font-medium ${
                currentPage === number ? 'bg-red-600 hover:bg-red-700' : 'text-text-white hover:bg-gray-600'
              }`}
            >
              {number}
            </button>
          ) : (
            <button
              key={index}
              disabled
              className="relative inline-flex items-center px-4 py-2 border border-gray-700 bg-gray-700 text-sm font-medium text-text-gray disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {number}
            </button>
          )
        )}
        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-700 bg-gray-700 text-sm font-medium text-text-white hover:bg-gray-600 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <FontAwesomeIcon icon={faChevronRight} />
        </button>
      </nav>
    </div>
  );
};

export default Pagination;